import type { Maybe } from 'graphql/jsutils/Maybe'
import type { ReadonlyAbort } from '@amazon/vinyl-util'

export function nextIntersection(
    view: HTMLElement,
    props?: Maybe<IntersectionObserverInit>,
    abort?: ReadonlyAbort
): Promise<void> {
    return new Promise((resolve, reject) => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    resolve()
                    observer.unobserve(view)
                }
            })
        }, props ?? {})
        abort?.on('abort', (event) => {
            observer.unobserve(view)
            reject(event.reason)
        })
        observer.observe(view)
    })
}
